const sum = (data) => {
  return data.reduce((prev, curr) => prev + curr);
};

export default sum;
